import { BsWhatsapp } from 'react-icons/bs';
import s from './tasks-callback-modal.module.css';
import { Button } from '../../../../../../components/button/button';
import { Container } from '../../../../../../components/container/container';
import { ModalProps, Modal } from '../../../../../../components/modal/modal';
import { Tooltip } from '../../../../../../features/tooltip/tooltip';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { TaskCallbackType } from '../../../../../../store/api/tasks-api';

export const TasksCallbackModal = (props: ModalProps) => {
  const params = useQueryParams().getQueryParams();
  const callback = params.callback;
  const { t } = useLang();

  const parsedCallback = callback ? (JSON.parse(callback) as TaskCallbackType) : null;

  const name = parsedCallback?.name;
  const phone = parsedCallback?.phone;
  const has_whatsapp = parsedCallback?.has_whatsapp;

  return (
    <Modal {...props} title={t('Обратная связь')} className={s.feature}>
      {name && <Container label={t('Имя')}>{name}</Container>}
      {phone && (
        <Container label={t('Телефон')}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            {phone}
            <Tooltip
              trigger={<BsWhatsapp style={{ color: has_whatsapp ? 'green' : 'red' }} />}
              behavior="hover"
            >
              {t('Наличие WhatsApp')}
            </Tooltip>
          </div>
        </Container>
      )}

      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose}>
          {t('Назад')}
        </Button>
      </div>
    </Modal>
  );
};
